import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';

/**
 * Fires $pageview on client-side route changes (init uses capture_pageview: false).
 */
const PosthogPageview: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    posthog.capture('$pageview', {
      path: `${location.pathname}${location.search}`,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default PosthogPageview;
